export default
{
	"sounds": [
		{
			"categoryName": "bril",
			"actionName": "brilaanreiken",
			"value": "bril.mp3"
		},
		{
			"categoryName": "mobielecomputerglucose",
			"actionName": "glucosemetinguitvoeren",
			"value": "controleer_glucose.mp3"
		},
		{
			"categoryName": "infuus",
			"actionName": "infuuscontroleren",
			"value": "controleer_infuus.mp3"
		},
		{
			"categoryName": "mobielecomputerfysio",
			"actionName": "fysiotherapieinschakelen",
			"value": "fysio.mp3"
		},
		{
			"categoryName": "cad",
			"actionName": "cadcontroleren",
			"value": "kath.mp3"
		},
		{
			"categoryName": "mobielecomputerlab",
			"actionName": "labwaardencontroleren",
			"value": "labwaarden.mp3"
		},
		{
			"categoryName": "medicatietoedienen",
			"actionName": "kalmerendemedicatietoedienen",
			"value": "medicatie.mp3"
		},
		{
			"categoryName": "ontbijt",
			"actionName": "ontbijtenaantafel",
			"value": "ontbijt.mp3"
		},
		{
			"categoryName": "whiteboard",
			"actionName": "invullen",
			"value": "opschrijven.mp3"
		},
		{
			"categoryName": "whiteboard",
			"actionName": "vervangen",
			"value": "opschrijven.mp3"
		},
		{
			"categoryName": "waskom",
			"actionName": "patientinbedwassen",
			"value": "wassen.mp3"
		},
		{
			"categoryName": "waterglas",
			"actionName": "patientstimulerenomwatertedrinken",
			"value": "water.mp3"
		},
		{
			"categoryName": "zweedseband",
			"actionName": "zweedsebanduitdoenwanneerpartnerarriveert",
			"value": "zweedseband.mp3"
		}
	]
}